module.exports = __webpack_public_path__ + "static/flutterwave-webhook-1adf36ae31ebcd60e933ede6f448d5bf.png";